import { defineMessages } from 'react-intl-next';

export const messages: {
	clearIconLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	inputPlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	inputPlaceholderSearchOnly: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	searchIconLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	searchIconLabel: {
		id: 'dynamic-cards-search-page.input_search_icon_label',
		defaultMessage: 'Search',
		description:
			'Label text for search icon shown in search input where user can click to type search query',
	},
	clearIconLabel: {
		id: 'dynamic-cards-search-page.input_clear_icon_label',
		defaultMessage: 'Clear',
		description:
			'Label text for clear icon shown in search input where user can click to clear the search query',
	},
	inputPlaceholder: {
		id: 'dynamic-cards-search-page.input_placeholder',
		defaultMessage: 'Search or ask anything',
		description: 'Placeholder text in primary search input',
	},
	inputPlaceholderSearchOnly: {
		id: 'dynamic-cards-search-page.input_placeholder_search_only',
		defaultMessage: 'Search anything',
		description: 'Placeholder text in primary search input',
	},
});
